// extracted by mini-css-extract-plugin
export var bullet = "chrono-bullet-module--bullet--GHfOh";
export var current = "chrono-bullet-module--current--ZocLy";
export var disablePointerEvents = "chrono-bullet-module--disablePointerEvents--hmIrC";
export var highlight = "chrono-bullet-module--highlight--uaRj-";
export var horizontalBullet = "chrono-bullet-module--horizontalBullet--hGYZl";
export var label = "chrono-bullet-module--label--uRXFO";
export var verticalBullet = "chrono-bullet-module--verticalBullet--LENpZ";